import { useQuery } from "@tanstack/react-query";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";

import { readCi, readCis } from "../services/ciApi";

export function useCiQuery(publicId, isOpen) {
  const { t } = useTranslation();

  return useQuery({
    queryKey: ["ci", publicId],
    queryFn: () => readCi(publicId),
    enabled: isOpen && !!publicId,
    gcTime: 5 * 60 * 1000, // 5 minutes
    onError: (error) => {
      toast.error(error.message || t("item.messages.fetchError"));
    },
  });
}

export function useCisQuery(
  { type_id = null, status_id = null, name = null, owner_id = null, site_id = null, sort_by = null, limit = null },
  onSuccess,
  enabled = true,
) {
  const params = {
    ...(type_id && { type_id }),
    ...(status_id && { status_id }),
    ...(name && { name }),
    ...(owner_id && { owner_id }),
    ...(site_id && { site_id }),
    ...(sort_by && { sort_by }),
    ...(limit && { limit }),
  };

  return useQuery({
    queryKey: ["cis", params, "selector"],
    queryFn: () => readCis(params),
    gcTime: 5 * 60 * 1000, // 5 minutes
    onSuccess,
    enabled,
  });
}
